import React from 'react';
import Link, { NavLink } from 'redux-first-router-link';

// Abstracts Link, incase library is changed in the future. Only need to update this file.
// Projects can import Link from the usual /components/ folder.
// This component can be used as <Link> or <Link nav>

const style = {
  '&:hover': {
    textDecoration: 'underline',
  }
}

export default ({ nav, children, ...props, preventDefault }) => {
  if (nav) {
    return <NavLink 
      {...props} 
      style={style} 
      exact={true} 
      shouldDispatch={!preventDefault}
      // onClick={(e) => { preventDefault && e.preventDefault(); props.onClick() }}
    >{children}</NavLink>
  } else {
    return <Link 
      {...props} 
      style={style}
      shouldDispatch={!preventDefault}
      // onClick={(e) => { preventDefault && e.preventDefault(); props.onClick() }}
    >{children}</Link>
  }
}



// WEBPACK FOOTER //
// ./src/components/Link/Link.js